package xim.poc.game.configuration.v0.tactics.behaviors

import xim.poc.ActorManager
import xim.poc.game.ActorState
import xim.poc.game.AttackContext
import xim.poc.game.CombatBonusAggregate
import xim.poc.game.configuration.ActorDamagedContext
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.v0.tactics.TacticsMatchInstance
import xim.poc.game.configuration.v0.tactics.TacticsMatchUnitTurn
import xim.poc.game.event.Event
import kotlin.math.roundToInt

class TacticsIroncladBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    private var friendAlive: Boolean = true

    override fun submitTurnPlan(match: TacticsMatchInstance, turn: TacticsMatchUnitTurn) {
        val friend = match.getUnits().firstOrNull { it.isEnemy() && it.id != actorState.id }
        friendAlive = friend != null && !friend.isDead()

        maybeFallDown(context = null)

        if (isFallenDown()) {
            submitWait(tpCost = 300)
        }

        if (friend == null || actorState.getHpp() >= friend.getHpp()) {
            riseUp()
        }

        if (!turn.hasSubmittedAction()) { super.submitTurnPlan(match, turn) }
    }

    override fun applyTacticsBehaviorBonuses(aggregate: CombatBonusAggregate) {
        if (isFallenDown()) {
            aggregate.physicalDamageTaken -= 100
            aggregate.magicalDamageTaken -= 100
            aggregate.allStatusResistRate += 100
            aggregate.regen += (actorState.getMaxHp() * 0.05f).roundToInt()
        }
    }

    override fun getSkills(): List<SkillId> {
        return if (isFallenDown()) { emptyList() } else { super.getSkills() }
    }

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        val baseScore = super.estimateSkillValue(query)

        val distance = query.originalPosition.distance(query.destinationPosition)
        val distanceMultiplier = if (distance > 0) { 0.5f } else { 1f }

        return distanceMultiplier * baseScore
    }

    override fun onBehaviorDamaged(context: ActorDamagedContext): List<Event> {
        maybeFallDown(context.actionContext)
        return emptyList()
    }

    private fun maybeFallDown(context: AttackContext?) {
        val friend = getMatch().getUnits().firstOrNull { it.isEnemy() && it.id != actorState.id } ?: return

        val hppDelta = friend.getHpp() - actorState.getHpp()
        if (hppDelta < 0.2f) { return }

        AttackContext.compose(context) { fallApart() }
    }

    private fun isFallenDown(): Boolean {
        return actorState.appearanceState == 1
    }

    private fun fallApart() {
        actorState.appearanceState = 1

        actorState.getStatusEffects().filter { it.statusEffect.debuff }
            .forEach { actorState.expireStatusEffect(it.statusEffect) }
    }

    private fun riseUp() {
        actorState.appearanceState = 0
        ActorManager[actorState.id]?.displayDead = false
    }

}